import React from 'react';
import { t } from '../lib/i18n';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 p-8">
                    <div className="max-w-lg text-center">
                        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
                            <span className="text-3xl">{'\u26A0'}</span>
                        </div>
                        <h1 className="text-2xl font-bold text-red-800 dark:text-red-300 mb-2">{t('errorOccurred')}</h1>
                        <p className="text-slate-600 dark:text-slate-400 mb-4">{t('errorDesc')}</p>
                        <pre className="text-xs text-left bg-red-50 dark:bg-red-900/20 p-4 rounded-lg overflow-auto max-h-40 text-red-700 dark:text-red-300 mb-4">{this.state.error?.message}</pre>
                        <button onClick={() => window.location.reload()} className="px-6 py-3 bg-copper-500 text-white rounded-lg hover:bg-copper-600 font-medium font-heading">
                            {t('refreshPage')}
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
